export default __webpack_public_path__ + "static/media/logo-dit.1e07dd1a.png";